// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  background:
    radial-gradient(ellipse 80% 60% at 10% 20%, rgba(139, 92, 246, 0.22) 0%, transparent 60%),
    radial-gradient(ellipse 70% 50% at 90% 80%, rgba(59, 130, 246, 0.20) 0%, transparent 60%),
    radial-gradient(ellipse 60% 60% at 50% 50%, rgba(236, 72, 153, 0.08) 0%, transparent 70%),
    linear-gradient(145deg, #dde8f8 0%, #c9d8f0 40%, #ddd4f5 100%);
}

.onboarding-card {
  width: 100%;
  max-width: 560px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.66);
  border: 1px solid rgba(255, 255, 255, 0.86);
  box-shadow: 0 14px 45px rgba(79, 142, 247, 0.2);
  backdrop-filter: blur(20px) saturate(170%);
  padding: 2rem;
}

.onboarding-progress {
  display: flex;
  gap: 0.45rem;
  justify-content: center;
  margin-bottom: 1.5rem;
}

.onboarding-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: rgba(148, 163, 202, 0.6);
}

.onboarding-dot.active {
  width: 28px;
  background: linear-gradient(120deg, #4f8ef7 0%, #9b6cf7 55%, #e06ff5 100%);
}

.onboarding-title {
  margin: 0;
  text-align: center;
  color: #1e2a40;
  font-size: clamp(1.4rem, 4vw, 1.9rem);
}

.onboarding-description {
  margin: 0.9rem auto 2rem;
  color: #4a5568;
  text-align: center;
  max-width: 460px;
  line-height: 1.6;
}

.onboarding-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.8rem;
}

.onboarding-skip,
.onboarding-next {
  border: none;
  border-radius: 10px;
  padding: 0.75rem 1.2rem;
  font-size: 0.95rem;
  cursor: pointer;
}

.onboarding-skip {
  background: transparent;
  color: #6b7280;
  border: 1px solid rgba(148, 163, 202, 0.55);
}

.onboarding-next {
  color: #fff;
  background: linear-gradient(120deg, #4f8ef7 0%, #9b6cf7 55%, #e06ff5 100%);
  box-shadow: 0 6px 18px rgba(139, 92, 246, 0.34);
}

@media (max-width: 520px) {
  .onboarding-card {
    padding: 1.5rem 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Onboarding.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB;;;;kEAIgE;AAClE;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,+CAA+C;EAC/C,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,0EAA0E;AAC5E;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,0EAA0E;EAC1E,+CAA+C;AACjD;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".onboarding-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 1rem;\n  background:\n    radial-gradient(ellipse 80% 60% at 10% 20%, rgba(139, 92, 246, 0.22) 0%, transparent 60%),\n    radial-gradient(ellipse 70% 50% at 90% 80%, rgba(59, 130, 246, 0.20) 0%, transparent 60%),\n    radial-gradient(ellipse 60% 60% at 50% 50%, rgba(236, 72, 153, 0.08) 0%, transparent 70%),\n    linear-gradient(145deg, #dde8f8 0%, #c9d8f0 40%, #ddd4f5 100%);\n}\n\n.onboarding-card {\n  width: 100%;\n  max-width: 560px;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.66);\n  border: 1px solid rgba(255, 255, 255, 0.86);\n  box-shadow: 0 14px 45px rgba(79, 142, 247, 0.2);\n  backdrop-filter: blur(20px) saturate(170%);\n  padding: 2rem;\n}\n\n.onboarding-progress {\n  display: flex;\n  gap: 0.45rem;\n  justify-content: center;\n  margin-bottom: 1.5rem;\n}\n\n.onboarding-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 999px;\n  background: rgba(148, 163, 202, 0.6);\n}\n\n.onboarding-dot.active {\n  width: 28px;\n  background: linear-gradient(120deg, #4f8ef7 0%, #9b6cf7 55%, #e06ff5 100%);\n}\n\n.onboarding-title {\n  margin: 0;\n  text-align: center;\n  color: #1e2a40;\n  font-size: clamp(1.4rem, 4vw, 1.9rem);\n}\n\n.onboarding-description {\n  margin: 0.9rem auto 2rem;\n  color: #4a5568;\n  text-align: center;\n  max-width: 460px;\n  line-height: 1.6;\n}\n\n.onboarding-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.8rem;\n}\n\n.onboarding-skip,\n.onboarding-next {\n  border: none;\n  border-radius: 10px;\n  padding: 0.75rem 1.2rem;\n  font-size: 0.95rem;\n  cursor: pointer;\n}\n\n.onboarding-skip {\n  background: transparent;\n  color: #6b7280;\n  border: 1px solid rgba(148, 163, 202, 0.55);\n}\n\n.onboarding-next {\n  color: #fff;\n  background: linear-gradient(120deg, #4f8ef7 0%, #9b6cf7 55%, #e06ff5 100%);\n  box-shadow: 0 6px 18px rgba(139, 92, 246, 0.34);\n}\n\n@media (max-width: 520px) {\n  .onboarding-card {\n    padding: 1.5rem 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
